module.exports = __webpack_public_path__ + "media/images/application/template/tick-white-d0ab9a1eb811a450d782141d6c5d8129.svg";